module.exports = __webpack_public_path__ + "static/5-e3bd84fd2296c5cdec7a845614ef5fc2.jpg";